<template>
    <div class="w-100">
        <div v-if="loading">
            <loading/>
        </div>
        <div>
            <div v-if="!showCalendar">
                <b-alert variant="warning" show>
                    Vous devez sélectionner un collaborateur pour afficher son
                    calendrier d'échéances
                </b-alert>
            </div>
            <div>
                <vc-calendar
                    ref="vc"
                    class="custom-calendar w-100 shadow"
                    :masks="masks"
                    :attributes="attributes"
                    :editable="true"
                    disable-page-swipe
                    is-expanded
                    @transition-end="getItems"
                >
                    <template #day-content="{ day, attributes }">
                        <div class="flex flex-col h-full z-10 overflow-hidden">
                            <span class="day-label text-sm text-gray-900">
                                {{ day.day }}
                            </span>
                            <div
                                class="flex-grow overflow-y-auto overflow-x-auto"
                            >
                                <b-link
                                    v-for="attr in attributes"
                                    :key="attr.key"
                                    @click="goTo(attr.customData)"
                                >
                                    <p
                                        class="vc-item leading-tight rounded-sm p-1 mb-1"
                                        :class="attr.customData.class"
                                        :style="attr.customData.style"
                                    >
                                        <i :class="attr.customData.icon" class="mr-1"></i>
                                        <span v-if="attr.customData.type==='deadline'">
                                            {{
                                                attr.customData.client_name +
                                                ' : ' +
                                                attr.customData.action_title
                                            }}
                                        </span>
                                        <span
                                            v-if="attr.customData.type==='bankHoliday' || attr.customData.type==='absence'">
                                            {{
                                                attr.customData.title
                                            }}
                                        </span>
                                    </p>
                                </b-link>
                            </div>
                        </div>
                    </template>
                </vc-calendar>
                <b-alert
                    variant="primary"
                    :show="showCalendar"
                    class="mt-4 mb-0 shadow"
                >
                    <h4>Abonnement au calendrier :</h4>
                    <p>
                        Vous pouvez vous abonner à ce calendrier en utilisant le
                        lien suivant. Ce lien fonctionne avec l'application
                        Outlook, Microsoft 365, Google calendar ainsi que le
                        calendrier Apple.
                    </p>
                    <p class="mb-0 font-weight-bold">
                        {{ iCalendarUrl }}
                    </p>
                </b-alert>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'DeadlinesCalendar',

    data() {
        const month = new Date().getMonth()
        const year = new Date().getFullYear()
        return {
            displayedMonth: month,
            displayedYear: year,

            masks: {
                weekdays: 'WWW',
            },
            attributes: [],
            deadlines: [],
            todos: [],
            bankHolidays: [],
            absences: [],
            meta: [],
            showCalendar: true,
            loading: false,
        }
    },

    created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'deadlines')
    },

    mounted() {
        this.getItems()
    },

    methods: {
        goTo(customData) {
            this.$store.commit('browsing/SET_YEAR', customData.year)
            this.$store.commit('reportingVM/SET_SEARCH', customData.client_name)
            window.location.href = customData.url
        },

        async getItems() {
            this.showCalendar = true
            if (this.filters.accountingFirmUser > 0) {
                try {
                    this.loading = true
                    const {year} = this.$refs.vc.pages[0]
                    const {month} = this.$refs.vc.pages[0]
                    const response = await axios.get(
                        `/reporting/calendar/${year}/${month}/${this.filters.accountingFirmUser}`
                    )
                    this.deadlines = response.data.data.deadlines.data
                    this.todos = response.data.data.todos.data
                    this.bankHolidays = response.data.data.bankHolidays.data
                    this.absences = response.data.data.absences.data
                    this.setAttributes()
                    this.meta = response.data.meta
                    this.loading = false
                } catch (error) {
                    console.log(error)
                    this.handleErrors(error.response)
                }
            } else {
                this.showCalendar = false
                this.attributes = []
            }
        },

        setAttributes() {
            if (this.clientsActivationFilter === 'all') {
                this.attributes = this.bankHolidays.concat(this.absences.concat(this.deadlines.concat(this.todos)))
            } else {
                const filteredDeadlines = this.deadlines.filter(
                    (item) => item.activation === this.clientsActivationFilter
                )
                const filteredTodos = this.todos.filter(
                    (item) => item.activation === this.clientsActivationFilter
                )
                this.attributes = this.bankHolidays.concat(this.absences.concat(filteredDeadlines.concat(filteredTodos)))
            }
        },

        handleErrors(errorResponse) {
            this.loading = false
            this.errorMessage =
                "Une erreur s'est produite, les données n'ont pu être chargées. Veuillez réactualiser la page."
            this.hasErrors = true
        },
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
            clientsActivationFilter: (state) => state.browsing.clientsActivationFilter

        }),
        iCalendarUrl() {
            return `${
                document.head.querySelector('meta[name="base-url"]').content
            }/i-calendar/${this.meta.accountingFirmUuid}/collaborateur/${
                this.meta.accountingFirmUserUuid
            }`
        },

    },
}
</script>

<style scoped></style>
